module.exports = __webpack_public_path__ + "img/Logo-bt-07.d0c41192.png";